export default __webpack_public_path__ + "static/media/Maithili_cf_2.0db26b2e.mp3";